import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "1400"
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t(_vm.reportModel.id ? 'AlarmLogs.reports.wizard.edit' : 'AlarmLogs.reports.wizard.createNew')) + "\n  ")];
      },
      proxy: true
    }])
  }, [[_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VStepper, {
    attrs: {
      "color": _vm.color,
      "non-linear": ""
    },
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c(VStepperHeader, [_c(VStepperStep, {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1",
      "color": _vm.color,
      "editable": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.define')) + "\n            " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinInformation')) + "\n          ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "editable": _vm.reportModel.tenantId && !!_vm.reportModel.meta.title,
      "complete": _vm.step > 2,
      "step": "2",
      "color": _vm.color
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.headerAlarmFilters')) + "\n          ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "step": "3",
      "color": _vm.color,
      "editable": _vm.reportModel.smartGroupId
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.headerAlarmConfiguration')) + "\n          ")])], 1), _c(VStepperItems, [_c(VStepperContent, {
    attrs: {
      "step": "1"
    }
  }, [_c('core-alarm-logs-report-wizard-meta-data', {
    attrs: {
      "reportModel": _vm.reportModel
    },
    on: {
      "change": _vm.updateReportModel,
      "nextStep": function ($event) {
        _vm.step = 2;
      }
    }
  })], 1), _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [_c('core-alarm-logs-report-wizard-filters', {
    attrs: {
      "reportModel": _vm.reportModel
    },
    on: {
      "change": _vm.updateReportModel,
      "nextStep": function ($event) {
        _vm.step = 3;
      }
    }
  })], 1), _c(VStepperContent, {
    attrs: {
      "step": "3"
    }
  }, [_c('core-alarm-logs-report-wizard-configuration', {
    attrs: {
      "reportModel": _vm.reportModel,
      "formValid": _vm.formValid
    },
    on: {
      "change": _vm.updateReportModel,
      "submitReport": _vm.submitReport
    }
  })], 1)], 1)], 1)], 1)]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };